export default "__VITE_ASSET__sTGSwXcP__"